




import { Component, Vue } from 'vue-property-decorator'
import SearchDetail from './components/SearchDetail.vue'

@Component({
  name: 'CreateSearch',
  components: {
    SearchDetail
  }
})
export default class extends Vue {}
